import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { WARRANTY } from '../constants'
import List from 'components/common/List/List'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Warranty from './Warranty'

const WarrantyList = ({ warranties = []}) =>
  <Fragment>
    <Title>{ WARRANTY }</Title>
    <List rare>
      { warranties.map((props, index) => <Warranty key={ index } { ...props } />) }
    </List>
  </Fragment>

WarrantyList.propTypes = {
  warranties: PropTypes.arrayOf(PropTypes.shape())
}

export default WarrantyList

const Title = styled.h3`
  margin: 21px 0 0;
  color: ${Theme.colors.black_new};
  text-transform: uppercase;
  ${Mixin.font.GothamBold(14)}
`
